const levels = [
  ['01', 'Separated', 'Each fleet keeps its own aisles. Nothing is shared but the building.', 'Week one'],
  ['02', 'Handover', 'One fleet finishes where the other starts, at a fixed point.', 'Proven'],
  ['03', 'Zone arbitration', 'A contested span is granted to one fleet at a time.', 'Fleet API'],
  ['04', 'Full control', 'One traffic model over every vehicle on the floor.', 'VDA 5050'],
] as const;

export function Levels() {
  return (
    <section className="sec" id="levels">
      <div className="sec__label">Four levels of shared floor</div>
      <h2 className="big drift drift--rev">Mix only as far<br />as the hardware allows.</h2>

      <p className="sec__sub reveal">
        What a site can run depends on what its vehicles already report and accept. Most floors
        start at 01 and move up.
      </p>

      <ol className="level-key reveal">
        {levels.map(([number, title, what, tag]) => (
          <li key={number}>
            <span>{number}</span><b>{title}</b><small>{what}</small><em>{tag}</em>
          </li>
        ))}
      </ol>
    </section>
  );
}
